import { ParentProps, Show, createContext, createEffect, createMemo, createSignal, useContext } from 'solid-js'
import { requireContext } from 'common'
import { K12GradReqOverviewDetailHeaderContext } from './K12GradReqOverviewDetailHeaderContext'
import styles from './sis-k12-grad-req-overview-detail-header.module.css'
import { STComponentWrapperProps, requireViewContext } from 'st-app';
import { ViewContext } from 'st-app';
import * as sis from '../../api/SISApp'
import K12GradReqOverviewDetailHeaderApi from '../../api/sis-k12-grad-req-overview-detail-header'
import { GradReqResultDetailHeaderData, RequirementStatus } from '../../api/SISApp';
import { getIconClasses } from '../sis-k12-gradreq-grade-layout/sis-k12-gradreq-grade-layout';

const K12GradReqOverviewDetailHeaderContextJsx = createContext<K12GradReqOverviewDetailHeaderContext>();
export const requireK12GradReqOverviewDetailHeaderContext = () => {
    return requireContext(K12GradReqOverviewDetailHeaderContextJsx);
}

export class K12GradReqOverviewDetailHeaderProps extends STComponentWrapperProps
{
    context?: K12GradReqOverviewDetailHeaderContext
}

const k12GradReqOverviewDetailHeaderContext = createContext<K12GradReqOverviewDetailHeaderContext>();
export const useK12GradReqOverviewDetailHeaderContext = () => useContext(k12GradReqOverviewDetailHeaderContext)!;

export default function K12GradReqOverviewDetailHeader(props: K12GradReqOverviewDetailHeaderProps) {
    const status = createMemo(() => props.value ?? '');
    const context = createMemo(() => props.context || new K12GradReqOverviewDetailHeaderContext(status));

    return (
        <K12GradReqOverviewDetailHeaderContextJsx.Provider value={context()}>
            <K12GradReqOverviewDetailHeaderInternal {...props} />
        </K12GradReqOverviewDetailHeaderContextJsx.Provider>
    )
}

function K12GradReqOverviewDetailHeaderInternal(props: K12GradReqOverviewDetailHeaderProps) {
    const [data, setData] = createSignal<GradReqResultDetailHeaderData | undefined>(undefined);

    createEffect(() => {
        if (props.value) {
            K12GradReqOverviewDetailHeaderApi.DeserializeData(props.value).then(value => setData(value));
        }
    });

    const getStatus = (status: RequirementStatus): string => {
        var res: string = "";
        switch (status) {
            default:
            case RequirementStatus.None:
                res = "N/A";
                break;
            case RequirementStatus.AtRisk:
                res = "At Risk";
                break;
            case RequirementStatus.Met:
                res = "Met";
                break;
            case RequirementStatus.NotMet:
                res = "Not Met";
                break;
            case RequirementStatus.OffTrack:
                res = "Off Track";
                break;
            case RequirementStatus.OnTrack:
                res = "On Track";
                break;
        }
        return res;
    }

    return (
        <Show when={data()} fallback={<h1>Loading...</h1>}>
            <div class={styles['sis-k12-grad-req-overview-detail-header']}>
                <div class="pxp-student-picker" aria-label="Student Selector" role="region">
                    <div class="student-card flexbox horizontal">
                        <div class="flexbox horizontal auto">
                            <div class={`${styles.imgHolder} flexbox vertical middle`} style="color: #aaa">
                                <span><img width="40" height="50" src={data()?.photo} /></span>
                                <span class="sis-number">{data()?.sisNumber}</span>
                            </div>
                            <div class="flexbox auto vertical">
                                <span class={styles.studentName} >{data()?.studentName}</span>
                                <span class={styles['small-text']}>{data()?.organizationName}</span>
                                <span class={styles['small-text']}>Grade {data()?.grade}</span>
                                <Show when={data()?.status != RequirementStatus.None}>
                                    <span class={styles.statusHolder}><span class={getIconClasses(data()?.status!)} />{getStatus(data()?.status!)}</span>
                                </Show>
                            </div>
                            <div class={`${styles.classReqHolder} flexbox auto vertical`}>
                                <span><span style="font-weight: 700">{data()?.graduationRequirement}</span> Class of <span style="font-weight: 700">{data()?.classOf}</span></span>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        </Show>
    );
}

K12GradReqOverviewDetailHeader.defaultProps = new K12GradReqOverviewDetailHeaderProps();
